exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text_center{text-align:center}.text-label,.text-point{cursor:pointer}.text-label{color:#2d8cf0;background:0 0;text-decoration:none;outline:0;transition:color .2s ease}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./src/components/sy-table/index.scss
// module id = 17
// module chunks = 0